module.exports = __webpack_public_path__ + "img/vehicleTramWhite.43e3ecae.svg";